<template>
  <div class="inline-role-form">
    <div
      class="inline-form-grid"
      :class="{ 'is-editing': isEditing }"
    >
      <div class="inline-form-group">
        <base-label :required="true">Название</base-label>
        <base-input
          v-model="form.name"
          placeholder="Например: Логист"
          :invalid="errors.name"
          @update:modelValue="errors.name = false"
        />
        <span v-if="errors.name" class="error-message">
          Это поле обязательно
        </span>
      </div>

      <div class="inline-form-group" v-if="!isEditing">
        <base-label :required="true">Код</base-label>
        <base-input
          v-model="form.code"
          placeholder="Например: logist"
          :invalid="errors.code"
          @update:modelValue="errors.code = false"
        />
        <span v-if="errors.code" class="error-message">
          Это поле обязательно
        </span>
      </div>

      <div class="inline-form-group inline-form-group--wide">
        <base-label>Стратегия новых прав</base-label>
        <base-select
          v-model="form.new_permissions_strategy"
          :options="strategyOptions"
          :clearable="false"
        />
      </div>
    </div>

    <div class="inline-form-actions">
      <base-primary-button
        @click="save"
        :loading="isLoading"
        class="btn-sm"
      >
        {{ submitLabel }}
      </base-primary-button>
      <base-button @click="$emit('cancel')" class="btn-sm">
        Отмена
      </base-button>
    </div>
  </div>
</template>

<script>
import { useNotificationStore } from "@/stores/notificationStore";

const STRATEGY_OPTIONS = [
  { value: "safe_actions", label: "Безопасные автоматически" },
  { value: "full_access", label: "Все новые права автоматически" },
  { value: "manual", label: "Только вручную" },
];

export default {
  name: "PermissionRoleForm",
  props: {
    initialData: { type: Object, default: null },
    isLoading: { type: Boolean, default: false },
    submitLabel: { type: String, default: "Сохранить" },
  },
  emits: ["save", "cancel"],
  data() {
    return {
      form: {
        name: "",
        code: "",
        new_permissions_strategy: "safe_actions",
      },
      errors: {
        name: false,
        code: false,
      },
      strategyOptions: STRATEGY_OPTIONS,
    };
  },
  computed: {
    isEditing() {
      return !!this.initialData;
    },
    notificationStore() {
      return useNotificationStore();
    },
  },
  methods: {
    initForm() {
      if (!this.initialData) return;
      this.form = {
        name: this.initialData.name || "",
        code: this.initialData.code || "",
        new_permissions_strategy:
          this.initialData.new_permissions_strategy || "manual",
      };
    },

    validate() {
      let isValid = true;
      this.errors = { name: false, code: false };

      if (!String(this.form.name).trim()) {
        this.errors.name = true;
        isValid = false;
      }

      if (!this.isEditing && !String(this.form.code).trim()) {
        this.errors.code = true;
        isValid = false;
      }

      if (!isValid) {
        this.notificationStore.showError(
          "Пожалуйста, заполните все обязательные поля"
        );
      }

      return isValid;
    },

    save() {
      if (!this.validate()) return;

      const payload = {
        name: this.form.name,
        new_permissions_strategy: this.form.new_permissions_strategy,
      };

      if (!this.isEditing) {
        payload.code = this.form.code;
      }

      this.$emit("save", payload);
    },
  },
  created() {
    this.initForm();
  },
};
</script>

<style scoped>
.inline-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: var(--base-in-indent);
}

.inline-form-grid.is-editing .inline-form-group:first-child {
  grid-column: 1 / -1;
}

.inline-form-group {
  display: flex;
  flex-direction: column;
}

.inline-form-group--wide {
  grid-column: span 2;
}

.inline-form-actions {
  display: flex;
  gap: 8px;
}

.btn-sm {
  padding: 6px 14px;
  font-size: 13px;
}

.error-message {
  margin-top: 5px;
  color: var(--color-danger);
  font-size: 12px;
}

@media (max-width: 600px) {
  .inline-form-grid {
    grid-template-columns: 1fr;
  }

  .inline-form-group--wide {
    grid-column: span 1;
  }
}
</style>
